import React, { useEffect } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { SCREEN_ROUTER } from "../../constants/screenRouter";
import { getLocalStorage } from "../../utils/localStorage";
import { STORAGE_KEY } from "../../constants/storageKeys";
import nextScreen from "../../utils/navigateScreen";
const Top = () => {
    const navigate = useNavigate();
    const handleInputCookie = (e) => {
        e.preventDefault();
        navigate(SCREEN_ROUTER.LOGIN_COOKIE)
    }

    const handleInputUserNamePassword = (e) => {
        e.preventDefault();
        navigate(SCREEN_ROUTER.LOGIN_ACCOUNT)
    }

    useEffect(() => {
        navigate(nextScreen(SCREEN_ROUTER.LOGIN_METHOD))
    }, []);

    return (
        <>
            <Container className="mt-3 d-flex justify-content-center">
                <Row className="w-100">
                    <Col xs={12} md={8} lg={6} className="mx-auto">
                        <div className="h4 mb-2 text-center">Đăng nhập bằng</div>
                        <Form className="shadow p-4 bg-white rounded" onSubmit={handleInputCookie}>
                            <Button className="w-75" variant="success" type="submit">
                                Cookie
                            </Button>
                        </Form>
                    </Col>
                </Row>
            </Container>
            <Container className="mt-3 d-flex justify-content-center">
                <Row className="w-100">
                    <Col xs={12} md={8} lg={6} className="mx-auto">
                        <Form className="shadow p-4 bg-white rounded" onSubmit={handleInputUserNamePassword}>
                            <Button className="w-75" variant="primary" type="submit">
                                Username và Password
                            </Button>
                        </Form>
                    </Col>
                </Row>
            </Container>
        </>
    )
}
export default Top;